import { StyleSheet } from 'react-native';

export const Styles = StyleSheet.create({
  row: { flexDirection: 'row' },
  rowReverse: { flexDirection: 'row-reverse' },
  // TODO this should be flexWrap: 'wrap'. requires usage audit to fix
  wrap: { alignSelf: 'flex-start' },
});
